import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {CompetitionsResponseDomainModel} from "../models/competitions.response-domain-model";
import {CompetitionsResponseApiModel} from "../models/competitions.response-api-model";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {SportsFactory} from "../../sports/domain-services/sports.factory";
import {CompetitionsFactory} from "./competitions-factory";
import {CompetitionsRepository} from "./competitions-repository";
import {CountryFactory} from "../../common/country/domain-services/country-factory";
import {CompetitionFactory} from "../../common/competition/domain-services/competition-factory";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {AppStore} from "../../../core/app/app-store";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {HistoryManager} from "../../../core/managers/history-manager";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {contractsUtils} from "../../../infrastructure/utils/contracts-utils";

export class CompetitionsDomainService extends BaseDomainService {
  sportFactory: SportsFactory;
  countryFactory: CountryFactory;
  competitionFactory: CompetitionFactory;

  static injectables = [...BaseManagedService.injectables, CompetitionsRepository, CompetitionsFactory, DomainRequestManager, CompetitionFactory, SportsFactory, CountryFactory, LoggerUtils];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    appStore: AppStore,
    navigationManager: NavigationManager,
    historyManager: HistoryManager,
    localStorageUtils: LocalStorageUtils,
    competitionsRepository: CompetitionsRepository,
    competitionsFactory: CompetitionsFactory,
    domainRequestManager: DomainRequestManager,
    competitionFactory: CompetitionFactory,
    sportFactory: SportsFactory,
    countryFactory: CountryFactory,
  ) {
    super(domUtils, logger, siteConfig, deviceStore, appStore, navigationManager, historyManager, localStorageUtils, competitionsRepository, competitionsFactory, domainRequestManager);

    contractsUtils.requiredType(competitionFactory, CompetitionFactory);
    contractsUtils.requiredType(sportFactory, SportsFactory);
    contractsUtils.requiredType(countryFactory, CountryFactory);

    this.competitionFactory = competitionFactory;
    this.sportFactory = sportFactory;
    this.countryFactory = countryFactory;
  }


  populateResponse(competitionsResponseApiModel: CompetitionsResponseApiModel): CompetitionsResponseDomainModel {
    if (!competitionsResponseApiModel || !competitionsResponseApiModel.competitions) {
      return null;
    }

    const countriesApiModelByCountryId = {};
    const sportsApiModelBySportId = {};
    const countriesDomainModel: Array<CountryDomainModel> = competitionsResponseApiModel.countries.map((country: CountryApiModel) => {
      countriesApiModelByCountryId[country.id] = country;

      return this.countryFactory.createDomainModel(country);
    });

    const sportsDomainModel: Array<SportDomainModel> = competitionsResponseApiModel.sports.map((sport: SportApiModel) => {
      sportsApiModelBySportId[sport.id] = sport;
      const sportDomainModel: SportDomainModel = new SportDomainModel(sport);

      return sportDomainModel;
    });

    const competitionsDomainModel: Array<CompetitionDomainModel> = competitionsResponseApiModel.competitions.map((competition: CompetitionApiModel) => {
      return this.competitionFactory.createDomainModel(competition, countriesApiModelByCountryId[competition.countryId], sportsApiModelBySportId[competition.sportId]);
    });

    const competitionsResponseDomainModel: CompetitionsResponseDomainModel = this.factory.createDomainModel(competitionsResponseApiModel, competitionsDomainModel, countriesDomainModel, sportsDomainModel);

    return competitionsResponseDomainModel;
  }
}

